import { makeStyle } from '../../utils';
import { button } from '../../resources/styles';

const styles = {};

styles['container'] = makeStyle({
    width: '100%',
    height: '100%',
    position: 'relative',
});

styles['search'] = makeStyle({
    position: 'absolute',
    top: 0, left: '50%', transform: 'translateX(-50%)',
    marginTop: 16,
    width: 300,
    backgroundColor: '#fffa',
    maxWidth: 'calc(100% - 32px)',
});

styles['pin'] = makeStyle({
    position: 'absolute',
    left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
});

styles['confirm'] = makeStyle({
    maxWidth: 'calc(100% - 32px)',
    position: 'absolute',
    left: '50%', transform: 'translateX(-50%)',
    bottom: 0,
    marginBottom: 16,
    borderRadius: 6,
    backgroundColor: 'var(--theme-color)',
    textAlign: 'center',
    color: 'white',
    padding: '8px 32px',
    ...button,
})

export default styles;